import axios, { AxiosInstance } from "axios";

import { appConfig } from "../AppConfig";

let partnerAxios: AxiosInstance;

export const usePartnerAxios = () => {
 
  if (!partnerAxios) {
    console.log("in usePartnerAxios")
    partnerAxios = axios.create();
    partnerAxios.interceptors.request.use(
      async (reqConfig) => {
        reqConfig.baseURL = appConfig.PartnerApiUrl;
        console.log("appConfig.PartnerApiUrl",appConfig.PartnerApiUrl)
        console.log("reqConfig",reqConfig)
        return reqConfig;
      },
      (error) => Promise.reject(error)
    );
  }

  return partnerAxios;
};
